import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 19h12v2H6v-2z"
}), 'MinimizeSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MinimizeSharp.js
// module id = 4844
// module chunks = 2